import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Tooltip } from 'components';
import * as styles from './NewClient.scss';
var NewClientFormStep3 = (_dec = connect(function (state) {
  return {
    formValues: state.newClient,
    organization: state.organization.current,
    theme: state.theme
  };
}, {}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(NewClientFormStep3, _Component);

  var _super = _createSuper(NewClientFormStep3);

  function NewClientFormStep3() {
    _classCallCheck(this, NewClientFormStep3);

    return _super.apply(this, arguments);
  }

  _createClass(NewClientFormStep3, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          contractInfo = _this$props.contractInfo,
          totals = _this$props.totals;
      var _this$props$formValue = this.props.formValues,
          orgConfig = _this$props$formValue.orgConfig,
          orgDetails = _this$props$formValue.orgDetails;
      var partnerName = contractInfo ? contractInfo.contract.businessName : 'Partner';
      console.log('totals type');
      console.log(_typeof(totals.totalBilledToPartner));
      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 52
        }
      }, /*#__PURE__*/React.createElement("section", {
        className: styles.summarySection
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.summaryTitle
      }, "Client Details"), (orgDetails.firstName !== '' || orgDetails.lastName !== '') && /*#__PURE__*/React.createElement("div", {
        className: styles.summaryItem
      }, "".concat(orgDetails.firstName, " ").concat(orgDetails.lastName)), /*#__PURE__*/React.createElement("div", {
        className: styles.summaryItem
      }, orgDetails.businessName), /*#__PURE__*/React.createElement("div", {
        className: styles.summaryItem
      }, orgDetails.email), orgDetails.address1 !== '' && /*#__PURE__*/React.createElement("div", {
        className: styles.summaryItem
      }, orgDetails.address1), orgDetails.address2 !== '' && /*#__PURE__*/React.createElement("div", {
        className: styles.summaryItem
      }, orgDetails.address2), /*#__PURE__*/React.createElement("div", {
        className: styles.summaryItem
      }, function () {
        var a = [orgDetails.city, orgDetails.state].filter(function (s) {
          return s;
        });
        var addressLine = "".concat(a.join(', ')).concat(orgDetails.zipCode ? " ".concat(orgDetails.zipCode) : '');
        return addressLine;
      }()), orgDetails.zipCode !== '' && /*#__PURE__*/React.createElement("div", {
        className: styles.summaryItem
      }), orgDetails.phone !== '' && /*#__PURE__*/React.createElement("div", {
        className: styles.summaryItem
      }, orgDetails.phone)), /*#__PURE__*/React.createElement("div", {
        className: styles.step3ClientDetails
      }, /*#__PURE__*/React.createElement("h2", {
        className: "".concat(styles.summaryTitle, " ").concat(styles.boxedSummaryTitle)
      }, "Confirmation")), totals.totalBilledToClient > 0 && /*#__PURE__*/React.createElement("div", {
        className: styles.step3Item
      }, orgDetails.businessName, " will be billed $", totals.totalBilledToClient), totals.totalBilledToPartner > 0 && /*#__PURE__*/React.createElement("div", {
        className: styles.step3Item
      }, partnerName, " will be billed $", totals.totalBilledToPartner), /*#__PURE__*/React.createElement("div", {
        className: styles.step3Item
      }, "Click Finish below to create your new client."), this.props.formValues.cardChargeError && this.props.formValues.cardChargeError !== '' && /*#__PURE__*/React.createElement("div", {
        className: styles.errorBox,
        style: {
          marginTop: 30
        }
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.stripeError
      }, this.props.formValues.cardChargeError)));
    }
  }]);

  return NewClientFormStep3;
}(Component)) || _class);
export { NewClientFormStep3 as default };